import { useMemo } from 'react'

/**
 * Ambient floating particles overlay. On the MC light theme these are soft
 * white motes (not fiery embers) at low opacity so they read as gentle
 * atmosphere without clashing with the blocky aesthetic. Purely decorative
 * and pointer-events: none.
 */
export default function AmbientEffects() {
  const motes = useMemo(() => {
    return Array.from({ length: 24 }, (_, i) => {
      const size = Math.random() * 3 + 2
      return {
        key: i,
        style: {
          left: `${Math.random() * 100}%`,
          animation: `${i % 2 === 0 ? 'float-up' : 'float-up-sway'} ${Math.random() * 10 + 8}s ${Math.random() * 10}s ease-in-out infinite`,
          width: `${size}px`,
          height: `${size}px`,
          opacity: Math.random() * 0.25 + 0.15,
        },
      }
    })
  }, [])

  return (
    <div
      style={{
        position: 'fixed',
        inset: 0,
        zIndex: 1,
        pointerEvents: 'none',
        overflow: 'hidden',
      }}
      aria-hidden="true"
    >
      {motes.map((mote) => (
        <div
          key={mote.key}
          className="ember"
          style={{
            position: 'absolute',
            bottom: '-10px',
            borderRadius: '50%',
            ...mote.style,
          }}
        />
      ))}
    </div>
  )
}
